import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";
import Slide from "@mui/material/Slide";
import { Link, useNavigate } from "react-router-dom";
import "./Header.css";
import { ROUTE_PATH } from "../../helper/Constants";
import { Button, FormControl, InputLabel, Select } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sagaActions } from "../../redux/sagas/sagaActions";
import {
  getLocalStorage,
  getSessionStorage,
  setLocalStorage,
} from "../../helper/Storage";

const pages = [{ text: "menu.qrcode", path: ROUTE_PATH.QRCODE }];

const Header = () => {
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const accessToken = getSessionStorage("token");

  const { t, i18n } = useTranslation();
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [langauge, setLangauge] = useState(
    getLocalStorage("userLanguage") ?? "en",
  );

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleSubmit = () => {
    dispatch({ type: sagaActions.USER_LOGOUT_REQUEST });
  };

  useEffect(() => {
    setLocalStorage("userLanguage", langauge);
    setLangauge(langauge);
    i18n.changeLanguage(langauge);
  }, [langauge, i18n]);

  useEffect(() => {
    if (!accessToken) {
      navigate("/");
    }
  }, [user, accessToken, navigate]);

  document.title = t(process.env.REACT_APP_TITLE);

  return (
    <Slide
      in="true"
      {...{ timeout: 400 }}
      transition={{ duration: 5000, delay: 0.1 }}
    >
      <AppBar position="sticky">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Box sx={{ display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{ display: { xs: "block", md: "none" }, textAlign: "left" }}
              >
                {accessToken &&
                  pages.map((page, index) => (
                    <MenuItem
                      key={"menuItem_" + index}
                      onClick={handleCloseNavMenu}
                      sx={{ textAlign: "left" }}
                    >
                      <Link to={page.path} className="menu-item">
                        {t(page.text)}
                      </Link>
                    </MenuItem>
                  ))}
                <MenuItem>
                  <FormControl>
                    <InputLabel
                      id="lang-select-label"
                      sx={{ color: "#000 !important" }}
                    >
                      {t("language")}
                    </InputLabel>
                    <Select
                      labelId="lang-select-label"
                      id="lang-select"
                      value={langauge}
                      label="Langauge"
                      onChange={(e) => {
                        setLangauge(e.target.value);
                      }}
                    >
                      <MenuItem value={"be"}>{t("bengali")}</MenuItem>
                      <MenuItem value={"en"}>{t("english")}</MenuItem>
                    </Select>
                  </FormControl>
                </MenuItem>
                {accessToken && (
                  <MenuItem
                    onClick={handleCloseNavMenu}
                    sx={{ textAlign: "left" }}
                  >
                    <Button variant="contained" onClick={handleSubmit}>
                      {t("logout")}
                    </Button>
                  </MenuItem>
                )}
              </Menu>
            </Box>
            <Box sx={{ flexGrow: { xs: 7, md: "revert", width: "60px" } }}>
              <Link to={ROUTE_PATH.BASE} className="menu-title">
                <img alt="logo" src="./images/logo.png"></img>
              </Link>
            </Box>
            <Box
              sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
              className="menu-item-container"
            >
              {accessToken &&
                pages.map((page, index) => (
                  <Link
                    key={"pages_" + index}
                    className="menu-item"
                    to={page.path}
                  >
                    {t(page.text)}
                  </Link>
                ))}
              <FormControl>
                <InputLabel
                  id="lang-select-label"
                  sx={{ color: "#000 !important" }}
                >
                  {t("language")}
                </InputLabel>
                <Select
                  labelId="lang-select-label"
                  id="lang-select"
                  value={langauge}
                  label="Langauge"
                  onChange={(e) => {
                    setLangauge(e.target.value);
                  }}
                >
                  <MenuItem value={"be"}>{t("bengali")}</MenuItem>
                  <MenuItem value={"en"}>{t("english")}</MenuItem>
                </Select>
              </FormControl>
            </Box>
            {accessToken && (
              <Box
                sx={{ flexGrow: 1, display: { xs: "none", md: "contents" } }}
              >
                <Box sx={{ padding: "0 15px" }}>{user?.user?.name}</Box>

                <Button variant="contained" onClick={handleSubmit}>
                  {t("logout")}
                </Button>
              </Box>
            )}
          </Toolbar>
        </Container>
      </AppBar>
    </Slide>
  );
};
export default Header;
